import React from 'react';

const BC_2d_euler_vortex = React.lazy(() => import('./2d-euler-vortex'));
const BC_2d_couette_flow = React.lazy(() => import('./2d-couette-flow'));
const BC_2d_double_mach_reflection = React.lazy(() => import('./2d-double-mach-reflection'));
const BC_2d_viscous_shock_tube = React.lazy(() => import('./2d-viscous-shock-tube'));
const BC_2d_inc_cylinder = React.lazy(() => import('./2d-inc-cylinder'));
const BC_3d_taylor_green = React.lazy(() => import('./3d-taylor-green'));
const BC_3d_triangular_aerofoil = React.lazy(() => import('./3d-triangular-aerofoil'));

const businessCaseRoutes = [
  { path: '/business-case/2d-euler-vortex', component: BC_2d_euler_vortex },
  { path: '/business-case/2d-couette-flow', component: BC_2d_couette_flow },
  { path: '/business-case/2d-double-mach-reflection', component: BC_2d_double_mach_reflection },
  { path: '/business-case/2d-viscous-shock-tube', component: BC_2d_viscous_shock_tube },
  { path: '/business-case/2d-inc-cylinder', component: BC_2d_inc_cylinder },
  { path: '/business-case/3d-taylor-green', component: BC_3d_taylor_green },
  { path: '/business-case/3d-triangular-aerofoil', component: BC_3d_triangular_aerofoil },
];

export default businessCaseRoutes;
